import {API_URL, VERSION} from "../config/config";
import Http from "axios";

async function fetchDynamicValues(key) {
    try {
        const response = await Http.get(`${API_URL}${VERSION}` + '/dynamic-values-setup/fetch-all', {
            params: {
                key
            }
        });
        let items = null
        if (key === 'UserSection') {
            items = response.data.map(item => {
                let iObj = {}
                iObj['name'] = item.value.name;
                iObj['id'] = item.id;
                return iObj
            })
        } else {
            items = response.data.map((item) => item.value);
            items = items.map(i => i.name);
            items.push('Others');
        }
        return items;
    } catch (e) {
        throw e;
    }
}

export {
    fetchDynamicValues
}
